// extracted by mini-css-extract-plugin
module.exports = {"preview":"AIImageSubtaskPreview_preview__3184Y","card":"AIImageSubtaskPreview_card__2XBS-"};